import { render } from "./InGame.vue?vue&type=template&id=74475b7c&scoped=true"
import script from "./InGame.vue?vue&type=script&lang=js"
export * from "./InGame.vue?vue&type=script&lang=js"

import "./InGame.vue?vue&type=style&index=0&id=74475b7c&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74475b7c"]])

export default __exports__